export const IDISC_ADMIN = "IDISC_ADMIN";
export const IDISC_PM = "IDISC_PM";
export const CLIENT_ADMIN = "CLIENT_ADMIN";
export const CLIENT_USER = "CLIENT_USER";
export const invitado = "invitado";